

import Form from "../../componets/Form";

export default function Section10() {
  return (
    <div className="mt-[-30px] md:mt-[0px]">
      <Form />
    </div>
  );
}
